import { Link } from "react-router-dom";
import { Sprout } from "lucide-react";
import { useFamily } from "../context/FamilyContext";

const COPY = {
  training: ["Training modules", "Short cards on dementia basics, safety and fall prevention, when to call 911, privacy and respect, and what helpers do not do. Each has one quiz question."],
  certificates: ["Upload certificates", "Soon you'll be able to add CPR or respite training certificates here."],
  identity: ["Identity check", "This is a placeholder. In the pilot, the Handoff team sets this up with you directly."],
  background: ["Background check", "This is a placeholder. In the pilot, the Handoff team sets this up with you directly."],
  export: ["Export visit log", "A CSV of every verified visit, for billing and reporting."],
};

export default function ComingSoon({ kind }) {
  const { base, paths } = useFamily();
  const [title, body] = COPY[kind];
  const back = kind === "export" ? `${base}/partner` : paths.helperHome;
  return (
    <div data-testid={`coming-soon-${kind}`} className="hf-card mt-4 text-center">
      <Sprout className="mx-auto h-12 w-12 text-hf-coral" />
      <p className="hf-eyebrow mt-4">Coming soon</p>
      <h1 className="mt-2 font-heading text-3xl font-semibold">{title}</h1>
      <p className="mx-auto mt-3 max-w-md text-lg text-hf-muted">{body}</p>
      <Link to={back} data-testid="coming-soon-back" className="hf-btn hf-btn-primary mt-8">Go back</Link>
    </div>
  );
}
